import PropTypes from "prop-types";

// Common components
import FilterButton from "@Layouts/components/Buttons/FilterButton";

function Filter(props) {
	const { apiRef, disabled } = props;
	return <FilterButton disabled={disabled} apiRef={apiRef} />;
}

Filter.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	disabled: PropTypes.bool,
};

export default Filter;
